import { useCallback } from 'react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { isNil } from 'ramda';
import { useDispatch, useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { ComponentLoader } from 'components';
import fetch from 'features/common/fetch';
import contactTake from 'features/views/contactTake';

export const ActionButtons = () => {
	const dispatch = useDispatch();
	const selectedContactId = useSelector(contactTake.selectors.getSelectedContactId);

	const handleTakeContact = useCallback(() => {
		dispatch(contactTake.actions.takeContact());
	}, [dispatch]);

	return (
		<Grid container>
			<Grid size={12}>
				<Grid container justifyContent="flex-end">
					<Grid size={3}>
						<ComponentLoader fetchStorePath={`${fetch.constants.urls.contactDetail}.take`} ignoreErrors>
							<Button
								variant="contained"
								fullWidth
								onClick={handleTakeContact}
								disabled={isNil(selectedContactId)}
							>
								{getLabelMessage('contactTake:take')}
							</Button>
						</ComponentLoader>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default ActionButtons;
